<template>
  <tr>
    <td>{{ device.model }}</td>
    <td>{{ device.serial_number }}</td>
    <td>
      <status-title :status="device.status" type="device"></status-title>
    </td>
    <td>
      <span v-if="!isOwnerDevice" class="text-danger small">{{
        $t('src/components/table-rows/devicetablerow.4996')
      }}</span>
      <span v-else-if="!hasCourse" class="text-danger small">{{
        $t('src/components/table-rows/devicetablerow.4997')
      }}</span>
      <router-link
        v-else
        :to="{ name: 'courses', params: { device: [device] } }"
        class="btn btn-outline-primary"
        >{{ $t('src/components/table-rows/devicetablerow.3890') }}</router-link
      >
    </td>
    <td>
      <button v-if="isNeuroAdmin" @click="resetDevice" type="button" class="btn btn-danger">
        {{ $t('button.delete') }}
      </button>
      <br v-if="isNeuroAdmin && isHospitalAdmin" />
      <button
        v-if="isHospitalAdmin && isOwnerDevice"
        @click="editDevice"
        type="button"
        class="btn btn-outline-primary"
        :class="{ 'mt-1': isNeuroAdmin }"
      >
        {{ $t('button.edit') }}
      </button>
    </td>
  </tr>
</template>

<script>
import StatusTitle from '@/components/StatusTitle.vue'
import { userRights } from '@/mixins/user-rights'

export default {
  name: 'DeviceTableBody',
  mixins: [userRights],
  components: {
    StatusTitle: StatusTitle
  },
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasCourse() {
      if (this.device.course.length == 0) return false
      else return true
    },
    isOwnerDevice() {
      return this.hospitalId == this.device.hospital_id
    },
    hospitalId() {
      if (this.isNeuroAdmin) {
        return this.$store.getters.SELECTED_HOSPITAL
      }
      if (this.$store.getters.AUTH_USER) {
        return this.$store.getters.AUTH_USER.hospital_id
      }
      return null
    }
  },
  methods: {
    editDevice() {
      this.$emit('edit:device', this.device)
    },
    resetDevice() {
      this.$emit('reset:device', this.device)
    }
  }
}
</script>
